export default __webpack_public_path__ + "static/media/monkey.80daa7ba.svg";